import React from 'react';

import { ActualOperation } from '../../types/interfaces';

export const JobIdTemplate = (job: ActualOperation | undefined) => {
  if (!job) {
    console.error('Invalid job data:', job);
    return null; // or handle the error accordingly
  }
  return <div>{!job.generatedID && job.id}</div>;
};

// @ts-ignore
const ActualJobBodyTemplate = ({ job, getTagStyle }) => {
  if (!job || !job.operation) {
    console.error('Invalid job data:', job);
    return null; // or handle the error accordingly
  }
  const label =
    typeof job.operation === 'object' ? job.operation?.label : job.operation;
  return <div style={{ ...getTagStyle(job.operation.key) }}>{label}</div>;
};

export default ActualJobBodyTemplate;
